import React, {HTMLAttributes} from 'react';
import {Client} from '@/api/dto/client-profile';
import {useAuthStore} from '@/store/auth_store';
import {NotificationLink} from '@/components/pages/notifications/links/NotificationLink';
import {SearchParam} from '@/helpers/search_params';
import PermissionsHelpers from '@/helpers/permissions_helpers';
import DisplayHelpers from '@/helpers/display_helpers';

type Props = HTMLAttributes<HTMLAnchorElement> & {
  client: Client;
  disabled?: boolean
};

export default function ClientLink({ client, disabled, ...props }: Props) {
  const { currentUser } = useAuthStore();

  const clientName = DisplayHelpers.formatName(
    client.firstName,
    client.middleName,
    client.lastName,
  );

  const rosterId = client.roster?.id;
  const searchParams = `${SearchParam.PATIENT_ID}=${client.patientId}&` +
    `${SearchParam.ROSTER_ID}=${rosterId}`;

  const effectiveRoster = client.roster;

  return !!currentUser && !!effectiveRoster && PermissionsHelpers.hasRosterAccess(currentUser, effectiveRoster) ? (
    <NotificationLink to={`/clients/profile?${searchParams}`} disabled={disabled} {...props}>
      {clientName}
    </NotificationLink>
  ) : (
    <>{clientName}</>
  );
}
